export function isNotEmpty(str: string) {
    if (str === "") {
        return "Champ vide n'est pas valide";
    }
    return true;
}

export function isValidRewards(rewards: number) {
    if (rewards < 0 || rewards > 9999) {
        return "Reward is required. It must be bewteen 0 and 9999";
    }
    return true;
}

export function isValidEmail(email: string) {
    /* eslint-disable no-useless-escape */
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (email && !email.split(";").every((address) => re.test(address.trim()))) {
        return "Courriel n'est pas valide";
    }
    return true;
}

export function isValidPhoneNumber(tel: string) {
    const re = /^(0|\+33)[1-9]([-. ]?[0-9]{2}){4}$/;
    if (tel && !re.test(tel)) return "Numéro de téléphone n'est pas valide";
    return true;
}

export function isValidName(name: string, errorMsg: string) {
    // Letters in any alphabet (accents included), words separated by a space, hyphen or apostrophe
    const re = /^\p{L}+(?:[ '’-]\p{L}+)*$/u;
    if (name && !re.test(name)) return errorMsg;
    return true;
}

export function isValidCodePostale(cp: string) {
    const re = /[0-9]{5}/g;
    const cpStr = String(cp);
    if (cpStr === "" || (cp && !re.test(String(cp)))) {
        return "Code postale n'est pas valide";
    }
    return true;
}

export function validateDate(date: string): string | true {
  if (!date || date.trim() === '') {
    return "Date obligatoire";
  }
  
  if (isNaN(Date.parse(date))) {
    return "Date invalide";
  }
  
  return true;
}

export function isValidFrenchDate(dateStr: string) {
     if (!dateStr) return "La date n'est pas valide";

    // Strict format check: dd/MM/YYYY
    const re = /^(\d{2})\/(\d{2})\/(\d{4})$/;
    const match = dateStr.match(re);
    if (!match) return "La date n'est pas valide";

    const day = Number(match[1]);
    const month = Number(match[2]);
    const year = Number(match[3]);

    // Month range
    if (month < 1 || month > 12) 
        return "La date n'est pas valide";

    // Days in each month
    const daysInMonth = new Date(year, month, 0).getDate(); 
    if (day < 1 || day > daysInMonth)
        return "La date n'est pas valide";

    return true;
}